<template>
    <div class="row">
        
        <b-card class="col-12" no-body >
            <div class="row">
                <div class="col-12 mb-3">
                    <b-button variant="primary" @click="create" v-if="permissao.c">{{ $t("GERAL.NOVO") }}</b-button>
                </div>
                <b-form class="col-12" @submit="onSearch">
                    <div class="row">
                        <input-text class="col-12" label="Filtrar" placeholder="Digite o proponente, tema, descrição ou área de interesse " v-model="filter">
                            <template #append>
                                <b-button variant="primary" class="ml-2" type="submit">Buscar</b-button>
                            </template>
                        </input-text>
                    </div>
                </b-form>
                
                
                <div class="col-12">
                    <b-table id="table" @row-dblclicked="open" head-variant="dark" hover :items="table.items" :fields="table.fields">
                        <template #cell(actions)="data">
                            <div class="d-flex">
                                <b-button variant="flat-primary" @click="open(data.item)" v-if="permissao.r">
                                    <i class="fas fa-edit"></i>
                                </b-button>
                                <b-button variant="flat-danger" @click="excluir(data.item)" v-if="permissao.d">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="table.currentPage"
                        :total-rows="table.dataLength"
                        :per-page="table.perPage"
                        @change="updatePagination"
                        align="center"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>

import DemandaService from "@/common/services/demanda/demanda.service.js";

import InputText from "@/components/inputs/InputText";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "../../common/mixins/AlertasMixin";

export default {
    mixins: [AlertasMixin],
    components: {
        InputText,
    },
    data: () => ({
        table: {
            fields : [
                {key: "empresa.nomeFantasia", label: "proponente" },
                {key: "temaSelecionado.tema.nome", label: "Tema" },
                {key: "descricao", label: "Descrição" },
                {key: "areaDeInteresse", label: "Área de interesse" },
                {key: "actions", label: "Ações" },
            ],
            items : [],
            perPage : 10,
            currentPage: 1,
            dataLength : 0,
        },
        filter: ""
    }),
    methods : {
        open: function(item) {
            if(this.permissao.r)
            this.$router.push({ name: "demanda-formulario", params: { id : item.id } });
        },
        excluir: function(item){
            this.confirmar("Deseja excluir a demanda?").then(confirmado => {
                if(!confirmado) return;

                this.$store.dispatch(START_LOADING);

                DemandaService.delete(item.id).then(() => {

                    this.alertaSucesso("Demanda excluida com sucesso!");
                    this.fetch();
                    
                }).catch(() => {

                    this.alertaErro("Erro ao excluir a demanda!");

                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
            

        },
        create: function() {
            this.$router.push({ name: "demanda-formulario" });
        },
        onSearch: function(e) {
            e.preventDefault();
            this.table.currentPage = 1
            this.fetch(this.filter);
        },
        updatePagination : function(page){
            this.fetch(this.filter, page - 1);
        },
        fetch: function(filter = "", page = 0){
            this.$store.dispatch(START_LOADING);
            
            DemandaService.fetch(filter, this.table.perPage , page).then(response => {
                this.table.items = response.data.data.itens;
                this.table.dataLength = response.data.data.paginacao.totalDeElementos;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });

        }
    },
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: "Banco de demandas" }
        ]);

        this.fetch();
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('BancoDemanda');
        },
    }
}
</script>
<style>
    
</style>